"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _BasePlugin2 = _interopRequireDefault(require("@uppy/core/lib/BasePlugin.js"));
var tus = _interopRequireWildcard(require("tus-js-client"));
var _EventManager = _interopRequireDefault(require("@uppy/core/lib/EventManager.js"));
var _NetworkError = _interopRequireDefault(require("@uppy/utils/lib/NetworkError"));
var _isNetworkError = _interopRequireDefault(require("@uppy/utils/lib/isNetworkError"));
var _RateLimitedQueue = require("@uppy/utils/lib/RateLimitedQueue");
var _hasProperty = _interopRequireDefault(require("@uppy/utils/lib/hasProperty"));
var _fileFilters = require("@uppy/utils/lib/fileFilters");
var _getFingerprint = _interopRequireDefault(require("./getFingerprint.js"));
var _excluded = ["onShouldRetry", "onBeforeRequest"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore untyped

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.5.5"
};
/**
 * Extracted from https://github.com/tus/tus-js-client/blob/master/lib/upload.js#L13
 * excepted we removed 'fingerprint' key to avoid adding more dependencies
 */
var tusDefaultOptions = {
  endpoint: '',
  uploadUrl: null,
  metadata: {},
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  overridePatchMethod: false,
  headers: {},
  addRequestId: false,
  chunkSize: Infinity,
  retryDelays: [100, 1000, 3000, 5000],
  parallelUploads: 1,
  removeFingerprintOnSuccess: false,
  uploadLengthDeferred: false,
  uploadDataDuringCreation: false
};
var defaultOptions = {
  limit: 20,
  retryDelays: tusDefaultOptions.retryDelays,
  withCredentials: false
};
var _retryDelayIterator = /*#__PURE__*/_classPrivateFieldLooseKey("retryDelayIterator");
var _uploadLocalFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadLocalFile");
var _getCompanionClientArgs = /*#__PURE__*/_classPrivateFieldLooseKey("getCompanionClientArgs");
var _uploadFiles = /*#__PURE__*/_classPrivateFieldLooseKey("uploadFiles");
var _handleUpload = /*#__PURE__*/_classPrivateFieldLooseKey("handleUpload");
/**
 * Tus resumable file uploader
 */
var Tus = exports.default = /*#__PURE__*/function (_BasePlugin) {
  function Tus(uppy, _opts) {
    var _this2;
    _classCallCheck(this, Tus);
    var _this$opts$rateLimite, _this$opts$retryDelay;
    _this2 = _callSuper(this, Tus, [uppy, _objectSpread(_objectSpread({}, defaultOptions), _opts)]);
    Object.defineProperty(_this2, _uploadFiles, {
      value: _uploadFiles2
    });
    Object.defineProperty(_this2, _getCompanionClientArgs, {
      value: _getCompanionClientArgs2
    });
    /**
     * Create a new Tus upload.
     *
     * A lot can happen during an upload, so this is quite hard to follow!
     * - First, the upload is started. If the file was already paused by the time the upload starts, nothing should happen.
     *   If the `limit` option is used, the upload must be queued onto the `this.requests` queue.
     *   When an upload starts, we store the tus.Upload instance, and an EventManager instance that manages the event listeners
     *   for pausing, cancellation, removal, etc.
     * - While the upload is in progress, it may be paused or cancelled.
     *   Pausing aborts the underlying tus.Upload, and removes the upload from the `this.requests` queue. All other state is
     *   maintained.
     *   Cancelling removes the upload from the `this.requests` queue, and completely aborts the upload-- the `tus.Upload`
     *   instance is aborted and discarded, the EventManager instance is destroyed (removing all listeners).
     *   Resuming the upload uses the `this.requests` queue as well, to prevent selectively pausing and resuming uploads from
     *   bypassing the limit.
     * - After completing an upload, the tus.Upload and EventManager instances are cleaned up, and the upload is marked as done
     *   in the `this.requests` queue.
     * - When an upload completed with an error, the same happens as on successful completion, but the `upload()` promise is
     *   rejected.
     *
     * When working on this function, keep in mind:
     *  - When an upload is completed or cancelled for any reason, the tus.Upload and EventManager instances need to be cleaned
     *    up using this.resetUploaderReferences().
     *  - When an upload is cancelled or paused, for any reason, it needs to be removed from the `this.requests` queue using
     *    `queuedRequest.abort()`.
     *  - When an upload is completed for any reason, including errors, it needs to be marked as such using
     *    `queuedRequest.done()`.
     *  - When an upload is started or resumed, it needs to go through the `this.requests` queue. The `queuedRequest` variable
     *    must be updated so the other uses of it are valid.
     *  - Before replacing the `queuedRequest` variable, the previous `queuedRequest` must be aborted, else it will keep taking
     *    up a spot in the queue.
     *
     */
    Object.defineProperty(_this2, _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(_this2, _retryDelayIterator, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this2, _handleUpload, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fileIDs) {
          var filesToUpload;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(fileIDs.length === 0)) {
                  _context.n = 1;
                  break;
                }
                _this2.uppy.log('[Tus] No files to upload');
                return _context.a(2);
              case 1:
                if (_this2.opts.limit === 0) {
                  _this2.uppy.log('[Tus] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/tus/#limit-0', 'warning');
                }
                _this2.uppy.log('[Tus] Uploading...');
                filesToUpload = _this2.uppy.getFilesByIds(fileIDs);
                _context.n = 2;
                return _classPrivateFieldLooseBase(_this2, _uploadFiles)[_uploadFiles](filesToUpload);
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        function value(_x) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    _this2.type = 'uploader';
    _this2.id = _this2.opts.id || 'Tus';
    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && 'metaFields' in _this2.opts) {
      throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
    }
    if ('autoRetry' in _opts) {
      throw new Error('The `autoRetry` option was deprecated and has been removed.');
    }

    /**
     * Simultaneous upload limiting is shared across all uploads with this plugin.
     *
     * @type {RateLimitedQueue}
     */
    _this2.requests = (_this$opts$rateLimite = _this2.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new _RateLimitedQueue.RateLimitedQueue(_this2.opts.limit);
    _classPrivateFieldLooseBase(_this2, _retryDelayIterator)[_retryDelayIterator] = (_this$opts$retryDelay = _this2.opts.retryDelays) == null ? void 0 : _this$opts$retryDelay.values();
    _this2.uploaders = Object.create(null);
    _this2.uploaderEvents = Object.create(null);
    _this2.handleResetProgress = _this2.handleResetProgress.bind(_this2);
    return _this2;
  }
  _inherits(Tus, _BasePlugin);
  return _createClass(Tus, [{
    key: "handleResetProgress",
    value: function handleResetProgress() {
      var files = _objectSpread({}, this.uppy.getState().files);
      Object.keys(files).forEach(function (fileID) {
        var _files$fileID;
        // Only clone the file object if it has a Tus `uploadUrl` attached.
        if ((_files$fileID = files[fileID]) != null && (_files$fileID = _files$fileID.tus) != null && _files$fileID.uploadUrl) {
          var tusState = _objectSpread({}, files[fileID].tus);
          delete tusState.uploadUrl;
          files[fileID] = _objectSpread(_objectSpread({}, files[fileID]), {}, {
            tus: tusState
          });
        }
      });
      this.uppy.setState({
        files: files
      });
    }

    /**
     * Clean up all references for a file's upload: the tus.Upload instance,
     * any events related to the file, and the Companion WebSocket connection.
     */
  }, {
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      var uploader = this.uploaders[fileID];
      if (uploader) {
        uploader.abort();
        if (opts != null && opts.abort) {
          uploader.abort(true);
        }
        this.uploaders[fileID] = null;
      }
      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }
    }
    /**
     * Store the uploadUrl on the file options, so that when Golden Retriever
     * restores state, we will continue uploading to the correct URL.
     */
  }, {
    key: "onReceiveUploadUrl",
    value: function onReceiveUploadUrl(file, uploadURL) {
      var currentFile = this.uppy.getFile(file.id);
      if (!currentFile) return;
      // Only do the update if we didn't have an upload URL yet.
      if (!currentFile.tus || currentFile.tus.uploadUrl !== uploadURL) {
        this.uppy.log('[Tus] Storing upload url');
        this.uppy.setFileState(currentFile.id, {
          tus: _objectSpread(_objectSpread({}, currentFile.tus), {}, {
            uploadUrl: uploadURL
          })
        });
      }
    }
  }, {
    key: "install",
    value: function install() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: true
        })
      });
      this.uppy.addUploader(_classPrivateFieldLooseBase(this, _handleUpload)[_handleUpload]);
      this.uppy.on('reset-progress', this.handleResetProgress);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: false
        })
      });
      this.uppy.removeUploader(_classPrivateFieldLooseBase(this, _handleUpload)[_handleUpload]);
    }
  }]);
}(_BasePlugin2.default);
function _uploadLocalFile2(file) {
  var _this3 = this;
  var _this = this;
  this.resetUploaderReferences(file.id);

  // Create a new tus upload
  return new Promise(function (resolve, reject) {
    var queuedRequest;
    var qRequest;
    var upload;
    var opts = _objectSpread(_objectSpread({}, _this3.opts), file.tus || {});
    if (typeof opts.headers === 'function') {
      opts.headers = opts.headers(file);
    }
    var onShouldRetry = opts.onShouldRetry,
      onBeforeRequest = opts.onBeforeRequest,
      commonOpts = _objectWithoutProperties(opts, _excluded);
    var uploadOptions = _objectSpread(_objectSpread({}, tusDefaultOptions), commonOpts);

    // We override tus fingerprint to uppy’s `file.id`, since the `file.id`
    // now also includes `relativePath` for files added from folders.
    // This means you can add 2 identical files, if one is in folder a,
    // the other in folder b.
    uploadOptions.fingerprint = (0, _getFingerprint.default)(file);
    uploadOptions.onBeforeRequest = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(req) {
        var xhr, userProvidedPromise, done, p;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              xhr = req.getUnderlyingObject();
              xhr.withCredentials = !!opts.withCredentials;
              if (typeof onBeforeRequest === 'function') {
                userProvidedPromise = onBeforeRequest(req, file);
              }
              if (!(0, _hasProperty.default)(queuedRequest, 'shouldBeRequeued')) {
                _context2.n = 3;
                break;
              }
              if (queuedRequest.shouldBeRequeued) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, Promise.reject());
            case 1:
              // eslint-disable-next-line promise/param-names
              p = new Promise(function (res) {
                done = res;
              });
              queuedRequest = _this3.requests.run(function () {
                if (file.isPaused) {
                  queuedRequest.abort();
                }
                done();
                return function () {};
              });
              // If the request has been requeued because it was rate limited by the
              // remote server, we want to wait for `RateLimitedQueue` to dispatch
              // the re-try request.
              // Therefore we create a promise that the queue will resolve when
              // enough time has elapsed to expect not to be rate-limited again.
              // This means we can hold the Tus retry here with a `Promise.all`,
              // together with the returned value of the user provided
              // `onBeforeRequest` option callback (in case it returns a promise).
              _context2.n = 2;
              return Promise.all([p, userProvidedPromise]);
            case 2:
              return _context2.a(2, undefined);
            case 3:
              return _context2.a(2, userProvidedPromise);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }();
    uploadOptions.onError = function (err) {
      var _queuedRequest;
      _this3.uppy.log(err);
      var xhr = err.originalRequest != null ? err.originalRequest.getUnderlyingObject() : null;
      if ((0, _isNetworkError.default)(xhr)) {
        // eslint-disable-next-line no-param-reassign
        err = new _NetworkError.default(err, xhr);
      }
      _this3.resetUploaderReferences(file.id);
      (_queuedRequest = queuedRequest) == null || _queuedRequest.abort();
      _this3.uppy.emit('upload-error', file, err);
      if (typeof opts.onError === 'function') {
        opts.onError(err);
      }
      reject(err);
    };
    uploadOptions.onProgress = function (bytesUploaded, bytesTotal) {
      _this3.onReceiveUploadUrl(file, upload.url);
      if (typeof opts.onProgress === 'function') {
        opts.onProgress(bytesUploaded, bytesTotal);
      }
      _this3.uppy.emit('upload-progress', _this3.uppy.getFile(file.id), {
        // TODO: remove `uploader` in next major
        // @ts-expect-error untyped
        uploader: _this3,
        bytesUploaded: bytesUploaded,
        bytesTotal: bytesTotal
      });
    };
    uploadOptions.onSuccess = function () {
      var _upload$url;
      var uploadResp = {
        uploadURL: (_upload$url = upload.url) != null ? _upload$url : undefined,
        status: 200,
        body: {}
      };
      _this3.resetUploaderReferences(file.id);
      queuedRequest.done();
      _this3.uppy.emit('upload-success', _this3.uppy.getFile(file.id), uploadResp);
      if (upload.url) {
        // @ts-expect-error not typed in tus-js-client
        var name = upload.file.name;
        _this3.uppy.log("Download ".concat(name, " from ").concat(upload.url));
      }
      if (typeof opts.onSuccess === 'function') {
        opts.onSuccess();
      }
      resolve(upload);
    };
    var defaultOnShouldRetry = function defaultOnShouldRetry(err) {
      var _err$originalResponse;
      var status = err == null || (_err$originalResponse = err.originalResponse) == null ? void 0 : _err$originalResponse.getStatus();
      if (status === 429) {
        // HTTP 429 Too Many Requests => to avoid the whole download to fail, pause all requests.
        if (!_this3.requests.isPaused) {
          var _classPrivateFieldLoo;
          var next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_this3, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo.next();
          if (next == null || next.done) {
            return false;
          }
          _this3.requests.rateLimit(next.value);
        }
      } else if (status != null && status > 400 && status < 500 && status !== 409 && status !== 423) {
        // HTTP 4xx, the server won't send anything, it's doesn't make sense to retry
        // HTTP 409 Conflict (happens if the Upload-Offset header does not match the one on the server)
        // HTTP 423 Locked (happens when a paused download is resumed too quickly)
        return false;
      } else if (typeof navigator !== 'undefined' && navigator.onLine === false) {
        // The navigator is offline, let's wait for it to come back online.
        if (!_this3.requests.isPaused) {
          _this3.requests.pause();
          window.addEventListener('online', function () {
            _this3.requests.resume();
          }, {
            once: true
          });
        }
      }
      queuedRequest.abort();
      queuedRequest = {
        shouldBeRequeued: true,
        abort: function abort() {
          this.shouldBeRequeued = false;
        },
        done: function done() {
          throw new Error('Cannot mark a queued request as done: this indicates a bug');
        },
        fn: function fn() {
          throw new Error('Cannot run a queued request: this indicates a bug');
        }
      };
      return true;
    };
    if (onShouldRetry != null) {
      uploadOptions.onShouldRetry = function (error, retryAttempt) {
        return onShouldRetry(error, retryAttempt, opts, defaultOnShouldRetry);
      };
    } else {
      uploadOptions.onShouldRetry = defaultOnShouldRetry;
    }
    var copyProp = function copyProp(obj, srcProp, destProp) {
      if ((0, _hasProperty.default)(obj, srcProp) && !(0, _hasProperty.default)(obj, destProp)) {
        // eslint-disable-next-line no-param-reassign
        obj[destProp] = obj[srcProp];
      }
    };

    // We can't use `allowedMetaFields` to index generic M
    // and we also don't care about the type specifically here,
    // we just want to pass the meta fields along.
    var meta = {};
    var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields
    // Send along all fields by default.
    : Object.keys(file.meta);
    allowedMetaFields.forEach(function (item) {
      // tus type definition for metadata only accepts `Record<string, string>`
      // but in reality (at runtime) it accepts `Record<string, unknown>`
      // tus internally converts everything into a string, but let's do it here instead to be explicit.
      // because Uppy can have anything inside meta values, (for example relativePath: null is often sent by uppy)
      meta[item] = String(file.meta[item]);
    });

    // tusd uses metadata fields 'filetype' and 'filename'
    copyProp(meta, 'type', 'filetype');
    copyProp(meta, 'name', 'filename');
    uploadOptions.metadata = meta;
    upload = new tus.Upload(file.data, uploadOptions);
    _this3.uploaders[file.id] = upload;
    var eventManager = new _EventManager.default(_this3.uppy);
    _this3.uploaderEvents[file.id] = eventManager;

    // eslint-disable-next-line prefer-const
    qRequest = function qRequest() {
      if (!file.isPaused) {
        upload.start();
      }
      // Don't do anything here, the caller will take care of cancelling the upload itself
      // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
      // called when this request is still in the queue, and has not been started yet, too. At
      // that point this cancellation function is not going to be called.
      // Also, we need to remove the request from the queue _without_ destroying everything
      // related to this upload to handle pauses.
      return function () {};
    };
    upload.findPreviousUploads().then(function (previousUploads) {
      var previousUpload = previousUploads[0];
      if (previousUpload) {
        _this3.uppy.log("[Tus] Resuming upload of ".concat(file.id, " started at ").concat(previousUpload.creationTime));
        upload.resumeFromPreviousUpload(previousUpload);
      }
    });
    queuedRequest = _this3.requests.run(qRequest);
    eventManager.onFileRemove(file.id, function (targetFileID) {
      queuedRequest.abort();
      _this3.resetUploaderReferences(file.id, {
        abort: !!upload.url
      });
      resolve("upload ".concat(targetFileID, " was removed"));
    });
    eventManager.onPause(file.id, function (isPaused) {
      queuedRequest.abort();
      if (isPaused) {
        // Remove this file from the queue so another file can start in its place.
        upload.abort();
      } else {
        // Resuming an upload should be queued, else you could pause and then
        // resume a queued upload to make it skip the queue.
        queuedRequest = _this3.requests.run(qRequest);
      }
    });
    eventManager.onPauseAll(file.id, function () {
      queuedRequest.abort();
      upload.abort();
    });
    eventManager.onCancelAll(file.id, function (_temp) {
      var _ref2 = _temp === void 0 ? {} : _temp,
        reason = _ref2.reason;
      if (reason === 'user') {
        queuedRequest.abort();
        _this.resetUploaderReferences(file.id, {
          abort: !!upload.url
        });
      }
      resolve("upload ".concat(file.id, " was canceled"));
    });
    eventManager.onResumeAll(file.id, function () {
      queuedRequest.abort();
      if (file.error) {
        upload.abort();
      }
      queuedRequest = _this3.requests.run(qRequest);
    });
  }).catch(function (err) {
    _this3.uppy.emit('upload-error', file, err);
    throw err;
  });
}
function _getCompanionClientArgs2(file) {
  var _file$remote;
  var opts = _objectSpread({}, this.opts);
  if (file.tus) {
    // Install file-specific upload overrides.
    Object.assign(opts, file.tus);
  }
  if (typeof opts.headers === 'function') {
    opts.headers = opts.headers(file);
  }
  return _objectSpread(_objectSpread({}, (_file$remote = file.remote) == null ? void 0 : _file$remote.body), {}, {
    endpoint: opts.endpoint,
    uploadUrl: opts.uploadUrl,
    protocol: 'tus',
    size: file.data.size,
    headers: opts.headers,
    metadata: file.meta
  });
}
function _uploadFiles2(_x3) {
  return _uploadFiles3.apply(this, arguments);
}
function _uploadFiles3() {
  _uploadFiles3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(files) {
    var _this4 = this;
    var filesFiltered, filesToEmit;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          filesFiltered = (0, _fileFilters.filterNonFailedFiles)(files);
          filesToEmit = (0, _fileFilters.filterFilesToEmitUploadStarted)(filesFiltered);
          this.uppy.emit('upload-start', filesToEmit);
          _context3.n = 1;
          return Promise.allSettled(filesFiltered.map(function (file) {
            if (file.isRemote) {
              var getQueue = function getQueue() {
                return _this4.requests;
              };
              var controller = new AbortController();
              var removedHandler = function removedHandler(removedFile) {
                if (removedFile.id === file.id) controller.abort();
              };
              _this4.uppy.on('file-removed', removedHandler);
              var uploadPromise = _this4.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase(_this4, _getCompanionClientArgs)[_getCompanionClientArgs](file), {
                signal: controller.signal,
                getQueue: getQueue
              });
              _this4.requests.wrapSyncFunction(function () {
                _this4.uppy.off('file-removed', removedHandler);
              }, {
                priority: -1
              })();
              return uploadPromise;
            }
            return _classPrivateFieldLooseBase(_this4, _uploadLocalFile)[_uploadLocalFile](file);
          }));
        case 1:
          return _context3.a(2);
      }
    }, _callee3, this);
  }));
  return _uploadFiles3.apply(this, arguments);
}
Tus.VERSION = packageJson.version;